import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../homepage/components/Header";
import Footer from "../homepage/components/Footer";
import Seo from "../../components/Seo";
import PortfolioGrid from "../homepage/components/PortfolioGrid";

const allowedCategories = new Set(["matte-painting", "concept-art"]);

const PortfolioPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const portfolioSchema = {
    "@context": "https://schema.org",
    "@type": "CreativeWork",
    name: "Skyline VFX Portfolio",
    description: "A portfolio of digital matte paintings, concept art, environment design, and VFX set extensions.",
  };

  const categoryFromUrl = useMemo(() => {
    const value = new URLSearchParams(location.search).get("category");
    return allowedCategories.has(value) ? value : null;
  }, [location.search]);

  const [selectedCategory, setSelectedCategory] = useState(categoryFromUrl ?? "matte-painting");

  useEffect(() => {
    if (categoryFromUrl && categoryFromUrl !== selectedCategory) {
      setSelectedCategory(categoryFromUrl);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoryFromUrl]);

  const handleCategoryChange = (categoryId) => {
    setSelectedCategory(categoryId);
    navigate(
      {
        pathname: "/portfolio",
        search: `?category=${encodeURIComponent(categoryId)}`,
      },
      { replace: true }
    );
  };

  return (
    <>
      <Seo
        title="Portfolio - Skyline VFX"
        description="Digital matte painting and concept art portfolio for Skyline VFX."
        schema={portfolioSchema}
      />
      <div className="min-h-screen text-white">
        <Header />
        <main className="pt-16">
          <PortfolioGrid
            selectedCategory={selectedCategory}
            onCategoryChange={handleCategoryChange}
          />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default PortfolioPage;

